import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

/**
 * Sticky action bar shown above a group list while one or more observation /
 * target rows are selected. "Delete selected" hands the resolved file ids to
 * the parent's bulk-delete handler; the parent owns the confirm + refresh.
 */
const SelectionBar = ({ count, onClear, onDelete }) => {
  if (!count) return null;
  return (
    <Box
      sx={{
        position: 'sticky', top: 0, zIndex: 3,
        display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap',
        px: 2, py: 1, mb: 1,
        bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: 1,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {count} selected
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      <Button size="small" onClick={onClear}>Clear</Button>
      <Button
        size="small"
        color="error"
        variant="outlined"
        startIcon={<DeleteIcon />}
        onClick={onDelete}
      >
        Delete selected
      </Button>
    </Box>
  );
};

export default SelectionBar;
